const budgetOptions = [
    {
      BudgetTypeId: 3,
      BudgetTypeName: "Month",
      BudgetType: "mn",
    },
    {
      BudgetTypeId: 1,
      BudgetTypeName: "Hour",
      BudgetType: "hr",
    },
    {
      BudgetTypeId: 5,
      BudgetTypeName: "Daily",
      BudgetType: "daily",
    },
    {
      BudgetTypeId: 2,
      BudgetTypeName: "Week",
      BudgetType: "wk",
    },
    {
      BudgetTypeId: 4,
      BudgetTypeName: "Year",
      BudgetType: "yr",
    },
  ];

  
export default budgetOptions;